export const setInSessionStorage = (props) => {
    const {key, value} = props
    try {
        (sessionStorage.setItem(key, JSON.stringify(value)))
      } catch (e) {
        console.log(e);
      }
}